import { Box } from "@mui/material";
import EfrisPanel from "components/Efris/EfrisPanel";

// EFRIS (URA e-invoicing). Keys are generated by RentBeta; landlords never paste private keys.
const EInvoicing = () => (
  <Box sx={{ p: 3 }}>
    <EfrisPanel />
  </Box>
);

export default EInvoicing;
